import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountAttributesEnum } from '../../../../enums';

@Component({
    selector: 'app-integrations-settings-item-menu',
    styleUrls: ['./integrations-settings-item-menu.component.scss'],
    templateUrl: './integrations-settings-item-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IntegrationsSettingsItemMenuComponent {
    @Input() isIntegrationSettingsOpened: boolean = false;
    @Output() dynamics: EventEmitter<void> = new EventEmitter<void>();
    @Output() hubspot: EventEmitter<void> = new EventEmitter<void>();
    @Output() marketo: EventEmitter<void> = new EventEmitter<void>();
    @Output() outreach: EventEmitter<void> = new EventEmitter<void>();
    @Output() salesforce: EventEmitter<void> = new EventEmitter<void>();
    @Output() salesloft: EventEmitter<void> = new EventEmitter<void>();
    @Output() zoho: EventEmitter<void> = new EventEmitter<void>();
    readonly accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;
    isOpen: boolean = false;

    onSalesforceSettings(): void {
        this.salesforce.emit();
    }

    onHubspotSettings(): void {
        this.hubspot.emit();
    }

    onMarketoSettings(): void {
        this.marketo.emit();
    }

    onOutreachSettings(): void {
        this.outreach.emit();
    }

    onSalesloftSettings(): void {
        this.salesloft.emit();
    }

    onDynamicsSettings(): void {
        this.dynamics.emit();
    }

    onZohoSettings(): void {
        this.zoho.emit();
    }
}
